import React from 'react';
import { Box, Divider, Skeleton, Stack } from '@mui/material';
import { useMediaDevice } from '@travelity/ui';
import { range } from 'lodash';

export interface ListMainProps {
    children: React.ReactNode;
    isLoading?: boolean;
    SkeletonComponent?: React.FC;
    hideOnPrint?: boolean;
}

export const ListMain: React.FC<ListMainProps> = React.memo(
    (props: ListMainProps) => {
        const { children, isLoading, hideOnPrint, SkeletonComponent } = props;
        const { isMobile } = useMediaDevice();

        return (
            <Box
                className={hideOnPrint ? 'hide-on-print' : ''}
                sx={{
                    bgcolor: '#FFF',
                    flexGrow: 2,
                    ml: 2,
                    my: { xs: 0, sm: 2 },
                    px: 2,
                    height: { xs: '100%', sm: 'calc(100% - 32px)' },
                    minWidth: '320px',
                    overflow: isLoading ? 'hidden' : 'initial',
                }}
            >
                {children}
                {isLoading && SkeletonComponent && (
                    <>
                        <Divider>
                            <Skeleton width={100} />
                        </Divider>

                        <Box
                            sx={{
                                py: 2,
                                bgcolor: '#F8F9FA',
                                height: 'calc(100% - 72px - 21px)',
                            }}
                        >
                            <Stack
                                sx={{
                                    px: isMobile ? 0 : 2,
                                }}
                                gap={1}
                            >
                                {range(1, 4).map(v => (
                                    <SkeletonComponent key={v} />
                                ))}
                            </Stack>
                        </Box>
                    </>
                )}
            </Box>
        );
    }
);
